export default "__VITE_ASSET__9d529a5f__"